import { useTranslation } from 'react-i18next';

import {
  ControlledAutoComplete,
  ControlledTextField
} from 'components/shared/ControlledFields';
import {
  FiltersContainer,
  SearchFieldBox,
  ValidityFieldBox
} from './ProtocolsFilters.styles';

import type { ProtocolsFiltersProps } from './ProtocolsFilters.types';

const ProtocolsFilters = ({
  control,
  validityOptions
}: ProtocolsFiltersProps) => {
  'use memo';
  const { t } = useTranslation('common');

  return (
    <FiltersContainer>
      <SearchFieldBox>
        <ControlledTextField
          control={control}
          name="search"
          label={t('search')}
        />
      </SearchFieldBox>
      <ValidityFieldBox>
        <ControlledAutoComplete
          disableSorting
          disableClearable
          optionLabelProp="name"
          idProperty="value"
          variant="outlined"
          control={control}
          name="validity"
          label={t('adminPortal.protocols.filter')}
          options={validityOptions}
          fullWidth
        />
      </ValidityFieldBox>
    </FiltersContainer>
  );
};

export default ProtocolsFilters;
